<template >
    <div class="product-list-element order-list" :class="{ updating }">
        <img class="cdn-image" :src="cdnImage"/>
        <div class="details-box" >

          <div class="sales-name"> {{product.salesName}}</div>
          <div class="sku"> {{$t('common.sku')}} <strong>{{product.SKU}}</strong> </div>
            <div class="availaibilty-message" >


                <img v-if="getAmountClass(product) === 'availability-low'" class="availability-noticer" src="@/assets/GreenInfoSmall.svg"/>
                <div :class="getAmountClass(product)">{{availabilityObject?.state?.message}}
                    <span v-if="getAmountClass(product) === 'availability-available'">( {{ getAvailable(product) }} )</span>
                    <span v-else> {{ getAvailable(product) }} </span>

                </div>


            </div>

            <div class="sku"  v-if="mode === 'summary'">
              <template v-if="dealerLocale() == 'fi'"> {{parseFloat(orderListPrice(product) * orderListAmount(product.SKU)).toLocaleString('fi-FI',{maximumFractionDigits:2, minimumFractionDigits:2})}}€</template>
              <template v-else> {{parseFloat(orderListPrice(product) * orderListAmount(product.SKU)).toLocaleString('nb-NB',{maximumFractionDigits:0})}}.-</template>
            </div>
            <div class="sku"  v-if="mode === 'list'">
              <template v-if="hasOfferPrice(product)">
                <span class="oldPrice">

                <template v-if="dealerLocale() == 'fi'">
                  {{parseFloat(orderListPrice(product) ).toLocaleString('fi-FI',{maximumFractionDigits:2, minimumFractionDigits:2})}}€
                </template>
                <template v-else>
                  {{parseFloat(orderListPrice(product)).toLocaleString('nb-NB',{maximumFractionDigits:0})}}.-
                </template>
                </span>

                <template v-if="dealerLocale() == 'fi'">
                  {{parseFloat(getOfferPrice(product) ).toLocaleString('fi-FI',{maximumFractionDigits:2, minimumFractionDigits:2})}}€
                </template>
                <template v-else>
                  {{parseFloat(getOfferPrice(product)).toLocaleString('nb-NB',{maximumFractionDigits:0})}}.-
                </template>

              </template>
              <template v-else>
                <template v-if="dealerLocale() == 'fi'">
                  {{parseFloat(orderListPrice(product) ).toLocaleString('fi-FI',{maximumFractionDigits:2, minimumFractionDigits:2})}}€
                </template>
                <template v-else>
                  {{parseFloat(orderListPrice(product)).toLocaleString('nb-NB',{maximumFractionDigits:0})}}.-
                </template>

              </template>
            </div>
            <div class="sku"  v-if="mode === 'party'">
              <template v-if="dealerLocale() == 'fi'"> {{parseFloat(orderListPrice(product) * orderListAmount(product.SKU)).toLocaleString('fi-FI',{maximumFractionDigits:2, minimumFractionDigits:2})}}€</template>
              <template v-else> {{parseFloat(orderListPrice(product) * orderListAmount(product.SKU)).toLocaleString('nb-NB',{maximumFractionDigits:0})}}.-</template>
            </div>




        </div>
        <div class="amount-box" v-if="custlist.processStatus.statusid === 3 && mode !== 'summary'">
            {{$t('common.amount', [orderListAmount(product.SKU)])}}
        </div>

        <div class="amount-box" v-else-if="(custlist.processStatus.statusid === 2 || mode === 'summary')" >
            {{$t('common.amount', [orderListAmount(product.SKU)])}}
        </div>



        <div class="pricing-box"  v-if="custlist.processStatus.statusid === 3 && mode !== 'summary'" >

            <!-- <FlyOut :items="flyoutActions" caption="Hjaldis Holmegren" style="margin-bottom: 10px"/> -->

            <!--

                 <img style="width: 41px;height: 41px;margin-right: -10px; cursor: pointer;" src="@/assets/ItemMenu.svg"/>
            -->


            <!-- HFA: Changed this to lookup orderactions based on lineid instead of SKU -->
           <div class="amount-box" v-if="orderActionsArrayByLineid(product.SKU).canMakeReturn ??  false">
     <!--           <ReturnButton class="widget-reserve-button" state='open' :text="$t('party.makeReturn')" @click="makeReturn(orderListLine(product.SKU))"/>
        -->
            </div>

            <div class="price">


              <div class="price" v-if="dealerLocale() == 'fi'"> {{parseFloat(orderListPrice(product) * orderListAmount(product.SKU)).toLocaleString('fi-FI',{maximumFractionDigits:2, minimumFractionDigits:2})}}€</div>
              <div v-else class="price"> {{parseFloat(orderListPrice(product) * orderListAmount(product.SKU)).toLocaleString('nb-NB',{maximumFractionDigits:0})}}.-</div>

            </div>
        </div>

        <div class="pricing-box" v-else-if="mode == 'summary'">
            <img style="width: 41px;height: 41px;margin-right: -10px; cursor: pointer;" src="@/assets/ItemMenu.svg"/>


          <div class="price" v-if="dealerLocale() == 'fi'"> {{parseFloat(orderListPrice(product) * orderListAmount(product.SKU)).toLocaleString('fi-FI',{maximumFractionDigits:2, minimumFractionDigits:2})}}€</div>
          <div v-else class="price"> {{parseFloat(orderListPrice(product) * orderListAmount(product.SKU)).toLocaleString('nb-NB',{maximumFractionDigits:0})}}.-</div>

        </div>

        <div class="pricing-box" v-if="product !== null">

            <div class="quantity-picker" v-if="custlist.processStatus.statusid < 2 && orderListContains(product.SKU)">
                <img class="decrease"  v-if="orderActionsArray(product.SKU)?.canDecreaseAmount" src="@/assets/RemoveCart.svg" @click="removeFromCart">
                <div class="amount">{{orderListAmount(product.SKU)}}</div>
                <img class="increase" v-if="orderActionsArray(product.SKU)?.canIncreaseAmount" src="@/assets/AddCart.svg" @click="addToCart">
                <img class="increase" v-else src="@/assets/AddCart.svg" style="opacity: 0.2;cursor:not-allowed">
            </div>

            <div class="reserve-box" style="padding: 6px" v-if="orderListContains(product.SKU) && line_type !== constants.LINE_PROFILING && orderActionsArray(product.SKU)" >
                <!--{{$t('common.status', [ line?.reservationStatus ?? orderListReservationStatus(product.SKU)])}}-->
                <div class="amount-box" v-if="orderActionsArray(product.SKU).canMakeReservation">
                    <ReserveButton class="widget-reserve-button" state='open'  :text="$t('party.reserveLine')" @click="makeReservation(orderListLine(product.SKU))"/>
                </div>

                <div class="amount-box"  v-if="orderActionsArray(product.SKU).canReleaseReservation" >
                    <ReserveButton class="widget-reserve-button" state='openable' :text="$t('party.releaseLine')" @click="releaseReservation(orderListLine(product.SKU))"/>
                </div>

                <div class="amount-box" v-if="custlist.processStatus.statusid < 2 && orderActionsArray(product.SKU).canMakeBackorder">
                    <BackorderButton class="widget-backorder-button" state='canBackorder'  :text="$t('party.makeBackorder')" @click="makeBackorder(orderListLine(product.SKU))"/>
                </div>

                <div class="amount-box"  v-if="custlist.processStatus.statusid < 2 && orderActionsArray(product.SKU).canCancelBackorder" >
                    <BackorderButton class="widget-backorder-cancel-button" state='backordered' :text="$t('party.cancelBackorder')" @click="cancelBackorder(orderListLine(product.SKU))"/>
                </div>

                <div class="amount-box" v-if="orderActionsArray(product.SKU).canMakeReturn">
                  
                    <ReturnButton class="widget-return-button" state='fresh'  :text="$t('party.makeReturn')" @click="makeReturn(orderListLine(product.SKU))"/>
                </div>

                <div class="amount-box"  v-if="orderActionsArray(product.SKU).canCancelReturn" >
                    <ReturnButton class="widget-return-button" state='activeRet' :text="$t('party.cancelReturn')" @click="cancelReturn(orderListLine(product.SKU))"/>
                </div>

            </div>

            <img  style="width: 44px;height: 44px;margin-top:10px;align-self:center;cursor: pointer;"
                  v-else-if="!orderListContains(product.SKU) && !(line_type === constants.LINE_ELEVATED_HOST_GIFT && !orderListContains(product.SKU) && custlist.processStatus.statusid < 2 )"
                  @click="addToCart" src="@/assets/PlusGreen.svg"/>

        </div>
    </div>

</template>

<script>
 import ReserveButton from "../../core/ReserveButton";
 import ReturnButton from "../../core/ReturnButton";
 import BackorderButton from "../../core/BackorderButton";
 import * as constants from '@/store/constants'
 import {mapGetters} from "vuex";
 export default {
     name: "ProductOrderListElement",
     props: {
         updating: { type: Boolean, default: false },
         line_type: {type: Number, default:1},
         product: {
             avatar: '',
             salesName:'',
             defaultPrice: 0,
             displaySeries:'',
             SKU:'',
             availability: {
                 state: {
                     state: "active",
                     message: "Tilgjengelig",
                     buyable: true
                 },
                 roof: 250,
                 qty: 190
             }
         },
         line: {
             quantity: 2,
             pricePrProduct: 229,
             id: -1,
             reservationStatus: 'open'
         },
         custlist:{
             id: -1,
             person: null,
             personId: -1,
             partyId: -1,
             sum: 0,
             lines: [
                 /*
                    {
                    "id": 4272474,
                    "productId": "27820",
                    "quantity": 1,
                    "pricePrProduct": null
                    }
                  */
             ],
             processStatus: {
                 statusid: 1,
                 statusDescription: "open",
                 canEdit: 1,
                 canOpen: 0
             }
         },
         mode: { type: String, default: 'list' }
     },
     components: {
         ReserveButton,
         BackorderButton,
         ReturnButton
     },
     computed: {
         ...mapGetters(['dealerLocale']),
         cdnImage () {
             let avatarFile = ''
             if (this.product?.images?.productMain?.length > 0 ?? false) {
                 if (this.product.images.productMain[0].image) {
                     avatarFile = this.product.images.productMain[0].image.name
                 }
             }
             if (!avatarFile){
                 return 'https://perfecthome.com/images/logo.svg'
             } else {
                 if (avatarFile.length > 0){
                     return `${process.env.VUE_APP_CDN_URL}images/pim/202/${avatarFile}`
                 } else {
                     return 'https://perfecthome.com/images/logo.svg'
                 }
             }

             //return `${process.env.VUE_APP_CDN_URL}images/pim/202/${avatarFile}`
         },

         constants(){
             return constants
         },
         seriesIdentifier () {
             return this.product.displaySeries.toUpperCase()
             // return this.product.salesName.substr(0, this.product.salesName.indexOf(' ')).toUpperCase()
         },
         availabilityObject(){
             return this.$store.getters.getStockItem(this.product.SKU)
         }
     },
     methods: {
         scrollToTop () {
             window.scrollTo(0, 0);
         },
       orderListContains (sku) {

         let arr = this.custlist.lines.filter(item => {
           return parseInt(item.productId) === parseInt(sku)

         })

         return arr.length > 0
       },

         orderListLine(sku){
             let arr = this.custlist.lines.filter(item => {
                 return parseInt(item.productId) === parseInt(sku) && item.productTypeId == this.line_type
             })
             if (arr.length) {
                 return arr[0].id
             }
             return -1
         },
         orderListReservationStatus(sku){
             let arr = this.custlist.lines.filter(item => {
                 return parseInt(item.productId) === parseInt(sku) && item.productTypeId == this.line_type
             })
             if (arr.length) {
                 return arr[0].reservationStatus
             }
             return ''
         },
         orderActionsArray(sku){
             let arr = this.custlist.lines.filter(item => {
                 return parseInt(item.productId) === parseInt(sku) && item.productTypeId == this.line_type


             })
             if (arr.length) {
                 let ret = {
                     canIncreaseAmount:arr[0].canIncreaseAmount == 1,
                     canDecreaseAmount:arr[0].canDecreaseAmount == 1,
                     canMakeReservation:arr[0].canMakeReservation == 1,
                     canReleaseReservation:arr[0].canReleaseReservation == 1,
                     canMakeBackorder:arr[0].canMakeBackorder ==1,
                     canCancelBackorder:arr[0].canCancelBackorder == 1,
                     canMakeReturn:arr[0].canMakeReturn ==1,
                     canCancelReturn:arr[0].canCancelReturn==1
                 }
                 return ret
             }
             return null
         },
         orderActionsArrayByLineid(sku){
             //Håvars attempt to move this over to lineid focus
             //Erik: rolled back to using sku+linetype combo, as ProductList does not get the line entity passed down - and that is the
             //wrapper component used in various contexts-  may need discussion
             //console.log("Looking up orderlist based on lineid:",sku);
             let arr = this.custlist.lines.filter(item => {
                 //  return parseInt(item.id) === parseInt(lineid)
                 
                 return parseInt(item.productId) === parseInt(sku) && item.productTypeId == this.line_type
             })
             if (arr.length) {
                 let ret = {
                     canIncreaseAmount:arr[0].canIncreaseAmount == 1,
                     canDecreaseAmount:arr[0].canDecreaseAmount == 1,
                     canMakeReservation:arr[0].canMakeReservation == 1,
                     canReleaseReservation:arr[0].canReleaseReservation == 1,
                     canMakeBackorder:arr[0].canMakeBackorder ==1,
                     canCancelBackorder:arr[0].canCancelBackorder == 1,
                     canMakeReturn:arr[0].canMakeReturn == 1,
                                                        canCancelReturn:arr[0].canCancelReturn==1
                 }
                 return ret
             } else {
                 return {
                     canIncreaseAmount:0,
                     canDecreaseAmount:0,
                     canMakeReservation:0,
                     canReleaseReservation:0,
                     canMakeBackorder:0,
                     canCancelBackorder:0,
                     canMakeReturn:0,
                     canCancelReturn:0
                 }
             }
             
         },
         orderListAmount (sku) {
             let arr = this.custlist.lines.filter(item => {
                 return parseInt(item.productId) === parseInt(sku)
             })
             if (arr.length > 0) {
                 return arr[0].quantity
             } else {
               return 0}
            // return 0
         },
         orderListPrice (prod) {

             let arr = this.custlist.lines.filter(item => {
                 return parseInt(item.productId) === parseInt(prod.sku)
             })
             if (arr.length > 0) {

                 return arr[0].pricePrProduct
             } else {

               return prod.defaultPrice
             }

         },
         hasOfferPrice (prod) {


           return prod.offerPrice < prod.defaultPrice

         },
         getOfferPrice(prod){
           return prod.offerPrice
         },
         addToCart () {
             //console.log(this.product.SKU)
             this.$emit('add-to-cart-clicked', this.custlist.id, this.product.SKU, 1)
         },
         removeFromCart () {
             this.$emit('remove-from-cart-clicked', this.custlist.id, this.product.SKU, this.line_type)
         },
         makeReservation (lineId) {
             this.$emit('make-reservation-clicked', this.custlist.id, lineId)
         },
         releaseReservation (lineId) {
             this.$emit('release-reservation-clicked', this.custlist.id, lineId)
         },
         makeBackorder(lineId){
             this.$emit('make-backorder-clicked', this.custlist.id, lineId)
         },
         cancelBackorder(lineId){
             this.$emit('cancel-backorder-clicked', this.custlist.id, lineId)
         },
         makeReturn(lineId){
             //console.log("make return clicked: " + this.custlist.id + " lineid: " + lineId);
             this.$router.push({name:'MakeClaim', params:{custlistid:this.custlist.id, lineid:lineId}})
             //console.log("make return clicked - post: " + this.custlist.id + " lineid: " + lineId);

             //   this.$emit('make-return-clicked', this.custlist.id, lineId)
         },
         cancelReturn(lineId){
             this.$emit('cancel-return-clicked', this.custlist.id, lineId)
         },
         getAmountClass(product){
             let stockObj = this.$store.getters.getStockItem(product.SKU)
             if(!stockObj){
                 return 'availability-unbuyable'
             }
             if(stockObj.state.buyable){
                 if(stockObj.qty <= 0){
                     return 'availability-unavailable'
                 }else if(stockObj.qty < 15){
                     return 'availability-low'
                 }else {
                     return 'availability-available'
                 }
             }else{
                 return 'availability-unbuyable'
             }
         },
         getAvailable(product){
             let stockObj = this.$store.getters.getStockItem(product.SKU)
             if(!stockObj){
                 return ''
             }
             if (!stockObj.state.buyable) {
                 return '0'
             } else {
                 if (stockObj.qty <= 0){
                     return '0'
                 } else {
                     if (stockObj.qty > stockObj.roof){
                         return '> ' + stockObj.displayQty
                     } else {
                         return stockObj.qty
                     }
                 }
             }
         }
     },
     emits: [
       'add-to-cart-clicked',
       'remove-from-cart-clicked',
       'make-backorder-clicked',
       'cancel-backorder-clicked',
       'cancel-return-clicked',
         'make-reservation-clicked',
       'release-reservation-clicked',
     ]
 }

</script>
<style scoped>
.button-primary{
    margin-bottom:5px;
}
@media screen and (max-width:482px) {
    .button-primary {
    height:55px;
    margin-bottom: 5px;
    line-height: 16px;
    font-size: 15px;
    margin-bottom:5px;
}
}

</style>
